export const STATUS = {
  CREATED: "created",
  REQUESTED: "requested",
  APPROVED_BY_DEPT_HEAD: "by_department",
  APPROVED_BY_DIRECTOR: "by_director",
  APPROVED_BY_F_N_A: "approved",
  REJECTED: "rejected",
  DISBURSED: "disbursed",
};

export const STATUS_LABELS = {
  [STATUS.CREATED]: "Created",
  [STATUS.REQUESTED]: "Pending Head Review",
  [STATUS.APPROVED_BY_DEPT_HEAD]: "Pending Director",
  [STATUS.APPROVED_BY_DIRECTOR]: "Pending F&A",
  [STATUS.APPROVED_BY_F_N_A]: "Pending Disbursement",
  [STATUS.REJECTED]: "Rejected",
  [STATUS.DISBURSED]: "Disbursed",
};

export const STATUS_COLORS = {
  [STATUS.CREATED]: "#8c8c8c",
  [STATUS.REQUESTED]: "#fa8c16",
  [STATUS.APPROVED_BY_DEPT_HEAD]: "#722ed1",
  [STATUS.APPROVED_BY_DIRECTOR]: "#1677ff",
  [STATUS.APPROVED_BY_F_N_A]: "#13c2c2",
  [STATUS.REJECTED]: "#ff4d4f",
  [STATUS.DISBURSED]: "#52c41a",
};

const DEFAULT_STATUS_COLOR = "#8c8c8c";

export function getStatusLabel(status) {
  if (!status) return "—";
  if (STATUS_LABELS[status]) return STATUS_LABELS[status];
  return String(status)
    .split("_")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

export function getStatusColor(status) {
  return STATUS_COLORS[status] || DEFAULT_STATUS_COLOR;
}
